import { gql } from '@apollo/client';

export const FETCH_USERS = gql`
  query FetchUsers {
    users {
      id
      email
      name
      surName
      roles
      rolActive
      permissions
      internal
      validated
      concessionIDs
      teamIDs
      isActive
      userType

      # Multi-tenant fields
      activeTenantId
    }
  }
`;

export const GET_OPERATORS = gql`
  query GetOperators {
    readOperators @client {
      id
      email
      name
      surName
      roles
      permissions
      internal
      validated
      concessionIDs
      isActive
      userType
    }
  }
`;

export const GET_OPERATORS_INTERNALS = gql`
  query GetOperatorsInternals {
    readOperatorsInternals @client {
      id
      email
      name
      surName
      roles
      permissions
      internal
      validated
      concessionIDs
      isActive
      userType
    }
  }
`;

export const GET_ACTIVE_OPERATORS = gql`
  query GetActiveOperators {
    readActiveOperators @client {
      id
      email
      name
      surName
      roles
      permissions
      internal
      validated
      concessionIDs
      isActive
      userType
    }
  }
`;

export const GET_OPERATORS_EXTERNALS = gql`
  query GetOperatorsExternals {
    readOperatorsExternals @client {
      id
      email
      name
      surName
      roles
      permissions
      internal
      validated
      isActive
      userType
    }
  }
`;

export const FETCH_TEAMS = gql`
  query FetchTeams {
    teams {
      id
      name
      isSurveillance
      concessionIDs
      roadIDs
      userIDs
      vehicleIDs
    }
  }
`;

// V4 D14 (2026-04-22): lista solo equipos `isSurveillance=true`, filtrados
// opcionalmente por concesión. Consumido por P3 (NewRoute selector de equipo
// de vigilancia) y P10 (TimerOverlay) para autofiltrar.
export const FETCH_SURVEILLANCE_TEAMS = gql`
  query SurveillanceTeams($concessionId: ID) {
    surveillanceTeams(concessionId: $concessionId) {
      id
      name
      isSurveillance
      concessionIDs
      roadIDs
      userIDs
      vehicleIDs
    }
  }
`;

export const GET_TEAM_BY_ID = gql`
  query GetTeamById($id: ID!) {
    team(id: $id) {
      id
      name
      isSurveillance
      concessionIDs
      roadIDs
      userIDs
      vehicleIDs
    }
  }
`;

export const GET_USER_BY_ID = gql`
  query GetUserById($input: FetchUser!) {
    user(input: $input) {
      id
      email
      name
      surName
      roles
      permissions
      internal
      validated
      concessionIDs
      teamIDs
      isActive
      userType

      # Multi-tenant fields
      activeTenantId
    }
  }
`;

// NUEVO: Queries para filtrar por userType (desde servidor)
export const FETCH_APP_USERS = gql`
  query FetchAppUsers {
    appUsers {
      id
      email
      name
      surName
      roles
      rolActive
      permissions
      internal
      validated
      concessionIDs
      teamIDs
      isActive
      userType

      # Multi-tenant fields
      activeTenantId
    }
  }
`;

export const FETCH_OPERATORS = gql`
  query FetchOperators {
    operators {
      id
      email
      name
      surName
      roles
      rolActive
      permissions
      internal
      validated
      concessionIDs
      teamIDs
      isActive
      userType

      # Multi-tenant fields
      activeTenantId
    }
  }
`;
